import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createD2hPublishMagazine,
  updateD2hPublishMagazine,
  getD2hPublishMagazine,
  deleteD2hPublishMagazine } from '../../../services/D2hPublishMagazineService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class D2hPublishMagazinePageEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {

      issue_id: '',
      issue_uuid: '',
      magazine_id: '',
      magazine_uuid: '',
      title: '',
      description: '',
      book_download_url: '',
      download_success_msg_body: '',
      download_success_msg_title: '',
      notify_cover_number: '',
      notify_when: '',
      date_created: '',
      status: '',

      errorMsg: null,
      currentUser: null,
      isLoading: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    // load info
    let d2hpublishmagazine = await getD2hPublishMagazine(this.props.match.params.id)
    log.debug(d2hpublishmagazine)

    this.setState({d2hpublishmagazineId: this.props.match.params.id})
    this.setState({

      issue_id: d2hpublishmagazine.issue_id === undefined ? '' : d2hpublishmagazine.issue_id,
      issue_uuid: d2hpublishmagazine.issue_uuid === undefined ? '' : d2hpublishmagazine.issue_uuid,
      magazine_id: d2hpublishmagazine.magazine_id === undefined ? '' : d2hpublishmagazine.magazine_id,
      magazine_uuid: d2hpublishmagazine.magazine_uuid === undefined ? '' : d2hpublishmagazine.magazine_uuid,
      title: d2hpublishmagazine.title === undefined ? '' : d2hpublishmagazine.title,
      description: d2hpublishmagazine.description === undefined ? '' : d2hpublishmagazine.description,
      book_download_url: d2hpublishmagazine.book_download_url === undefined ? '' : d2hpublishmagazine.book_download_url,
      download_success_msg_body: d2hpublishmagazine.download_success_msg_body === undefined ? '' : d2hpublishmagazine.download_success_msg_body,
      download_success_msg_title: d2hpublishmagazine.download_success_msg_title === undefined ? '' : d2hpublishmagazine.download_success_msg_title,
      notify_cover_number: d2hpublishmagazine.notify_cover_number === undefined ? '' : d2hpublishmagazine.notify_cover_number,
      notify_when: d2hpublishmagazine.notify_when === undefined ? '' : d2hpublishmagazine.notify_when,
      date_created: d2hpublishmagazine.date_created === undefined ? '' : d2hpublishmagazine.date_created,
      status: d2hpublishmagazine.status === undefined ? '' : d2hpublishmagazine.status,

      })
    // setup for moment DatePicker
    this.setState({date_created: moment(d2hpublishmagazine.date_created)})

    log.debug(this.state)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleDateChange(date) {
    this.setState({
      date_created: date
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    log.debug(this.state.date_created.toDate())

    let d2hpublishmagazine = {

      issue_id: this.state.issue_id ,
      issue_uuid: this.state.issue_uuid ,
      magazine_id: this.state.magazine_id ,
      magazine_uuid: this.state.magazine_uuid ,
      title: this.state.title ,
      description: this.state.description ,
      book_download_url: this.state.book_download_url ,
      download_success_msg_body: this.state.download_success_msg_body ,
      download_success_msg_title: this.state.download_success_msg_title ,
      notify_cover_number: this.state.notify_cover_number ,
      notify_when: this.state.notify_when ,
      date_created: this.state.date_created.toDate() ,
      status: this.state.status ,
    }
    log.debug(d2hpublishmagazine)

    try{
      let result = await updateD2hPublishMagazine(this.state.d2hpublishmagazineId, d2hpublishmagazine)
      log.debug('update success')
      //redirect to view
      this.props.history.push(`/d2hpublishmagazine/view/${this.state.d2hpublishmagazineId}`)
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/d2hpublishmagazine'>D2hPublishMagazine</Link> -> &nbsp;
          <Link to={`/d2hpublishmagazine/view/${this.state.d2hpublishmagazineId}`}>{this.state.title}</Link>  ->&nbsp;
          Edit
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }


          <div className="form-group">
            <label htmlFor="issue_id" className="col-sm-2 control-label">issue_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_id"
                value={this.state.issue_id}
                onChange={this.handleInputChange}
                placeholder="issue_id"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_uuid" className="col-sm-2 control-label">issue_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_uuid"
                value={this.state.issue_uuid}
                onChange={this.handleInputChange}
                placeholder="issue_uuid"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_id" className="col-sm-2 control-label">magazine_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_id"
                value={this.state.magazine_id}
                onChange={this.handleInputChange}
                placeholder="magazine_id"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_uuid" className="col-sm-2 control-label">magazine_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_uuid"
                value={this.state.magazine_uuid}
                onChange={this.handleInputChange}
                placeholder="magazine_uuid"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="book_download_url" className="col-sm-2 control-label">book_download_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="book_download_url"
                value={this.state.book_download_url}
                onChange={this.handleInputChange}
                placeholder="book_download_url"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_body" className="col-sm-2 control-label">download_success_msg_body:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_body"
                value={this.state.download_success_msg_body}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_body"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_title" className="col-sm-2 control-label">download_success_msg_title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_title"
                value={this.state.download_success_msg_title}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_title"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="notify_cover_number" className="col-sm-2 control-label">notify_cover_number:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_cover_number"
                value={this.state.notify_cover_number}
                onChange={this.handleInputChange}
                placeholder="notify_cover_number"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="notify_when" className="col-sm-2 control-label">notify_when:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_when"
                value={this.state.notify_when}
                onChange={this.handleInputChange}
                placeholder="notify_when"/>
            </div>
          </div>
          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_created"
                value={this.state.date_created}
                onChange={this.handleInputChange}
                placeholder="date_created"/>
            </div>
          </div> */}

          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status"/>
            </div>
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Edit</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/D2hPublishMagazinePage/D2hPublishMagazinePageEdit.js